var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavoriteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.21472 0.744815C4.30452 0.468421 4.69554 0.468421 4.78535 0.744815L5.58518 3.20645C5.62535 3.33006 5.74053 3.41375 5.8705 3.41375L8.45882 3.41375C8.74943 3.41375 8.87027 3.78563 8.63515 3.95645L6.54116 5.47783C6.43601 5.55422 6.39202 5.68963 6.43218 5.81324L7.23201 8.27487C7.32182 8.55126 7.00547 8.7811 6.77036 8.61028L4.67637 7.08891C4.57122 7.01251 4.42884 7.01251 4.3237 7.08891L2.2297 8.61028C1.99459 8.7811 1.67825 8.55126 1.76805 8.27487L2.56789 5.81324C2.60805 5.68963 2.56405 5.55422 2.4589 5.47783L0.364912 3.95645C0.129798 3.78563 0.25063 3.41375 0.541247 3.41375L3.12956 3.41375C3.25953 3.41375 3.37472 3.33006 3.41488 3.20645L4.21472 0.744815Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteIcon);
export default __webpack_public_path__ + "static/media/favorite_icon.cbc973ad8bdc79240b289ff1064feb29.svg";
export { ForwardRef as ReactComponent };